import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Box from 'grommet/components/Box'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'

import Footer from '../components/Footer'
import Header from '../components/Header'
import ContentDisplay from '../components/ContentDisplay'

import '../styles/FullContentDisplay.css'

class FullContentDisplay extends Component {
  render () {
    const {
      title,
      subtitle,
      content,
      contentDisplayType
    } = this.props.data

    return (
      <div className='FullContentDisplay'>
        <Header bg='primary-1' />

        <Box align='center'>
          <Heading align='center' margin='none'>{title}</Heading>
          <Paragraph align='center' size='large'>{subtitle}</Paragraph>
          <div className='frame'>
            <ContentDisplay content={content} contentDisplayType={contentDisplayType} />
          </div>
        </Box>

        <Footer
          isRoot={this.props.isRoot}
          history={this.props.history} />
      </div>
    )
  }
}

FullContentDisplay.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default FullContentDisplay



// WEBPACK FOOTER //
// ./src/layouts/FullContentDisplay.js